/* DON'T EDIT THIS FILE: edit original and run build again */ export const EMAIL = "EM";
export const FACEBOOK = "FA";
export const TWIITER = "TW";
export const AFIP = "AF";
// Premium accounts
export const PHONE_NUMBER = "PH";
